import { render } from "./manage-product-release.vue?vue&type=template&id=19a2c239"
import script from "./manage-product-release.vue?vue&type=script&lang=js"
export * from "./manage-product-release.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__